import { useNavigate } from "react-router-dom";
import useBrowseState from "../../hooks/useBrowseState";
import { LATEST_PATH } from "../../routes";

export default function MarketIntro() {
  const navigate = useNavigate();
  const { latest } = useBrowseState();

  return (
    <section className="marketIntro">
      <h2>
        <button type="button" id="v123WhatsNew" className={latest ? "active" : ""} onClick={() => navigate(LATEST_PATH)}>
          Shop what’s new ›
        </button>
      </h2>
      <p>
        Browse current items, add what you’re interested in, and submit an inquiry. No payment is collected on this
        website.
      </p>
      <div id="v123LatestLabel" className={latest ? "on" : ""}>
        Latest Listings
      </div>
    </section>
  );
}
